module.exports = __webpack_public_path__ + "media/components/src/assets/images/gallery_1-022323fc6e0605ef390ecb5934924700.jpg";